import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { getHelpOrError, hasError } from './_common';

const Input = (props) => {
  const {
    type,
    label,
    name,
    errors,
    value,
    onBlur,
    help,
    onChange,
    required,
    multiline,
    rows,
    inputProps,
    ...rest
  } = props;

  const onKeyPress = type !== 'number'
    ? null
    : (event) => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    };

  return (
    <TextField
      label={label}
      margin="dense"
      name={name}
      type={type || 'text'}
      value={value || ''}
      fullWidth
      onBlur={onBlur}
      onKeyPress={onKeyPress}
      helperText={getHelpOrError(help, errors, name)}
      error={hasError(errors, name)}
      onChange={onChange}
      required={required}
      multiline={multiline}
      rows={rows}
      inputProps={{
        autoComplete: type && type === 'password' ? 'new-password' : 'off',
        ...inputProps,
      }}
      {...rest}
    />
  );
};

Input.propTypes = {
  type: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  errors: PropTypes.shape({}),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  help: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  inputProps: PropTypes.shape({}),
};

export default Input;
